import axios from "axios";

export default class CharacteristicType {
  constructor() {
    this.base_url = process.env.REACT_APP_URL_PERSON;
    this.name = "/characteristic_types";
    this.url = this.base_url + this.name;
  }

  grid = async (skip = 0, take = 100) => {
    return await axios.get(`${this.url}?skip=${skip}&take=${take}`);
  };

  changeActive = async (id) => {
    await axios.patch(`${this.url}/${id}`);
  };
}
